import { render } from "./Kisi.vue?vue&type=template&id=ac62d4a4&scoped=true"
import script from "./Kisi.vue?vue&type=script&lang=js"
export * from "./Kisi.vue?vue&type=script&lang=js"

import "./Kisi.vue?vue&type=style&index=0&id=ac62d4a4&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac62d4a4"]])

export default __exports__